<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <div class="flex flex-wrap justify-center gap-y-3 md:gap-0 sm:justify-between w-full px-4 py-2 items-center">
      <div class="text-xl font-bold w-full sm:w-auto text-center">
        Información Rendimientos
      </div>
      <button @click="descargarInformeGrupal()" :disabled="descargandoInforme"
              class="px-4 py-2 text-white bg-blue-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none disabled:bg-blue-300 disabled:cursor-not-allowed disabled:hover:bg-blue-300">
        <svg v-if="descargandoInforme" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             class="inline-block w-6 h-6 animate-spin">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
        </svg>
        <span class="ml-3">{{ descargandoInforme ? 'Generando informe...' : 'Descargar informe' }}</span>
      </button>
    </div>
    <FilterRefactComponent :auth-token="authToken" :table-columns="tableColumns" :queries="queries"
                           @updateValues="(res) => {queries = res.queries}"></FilterRefactComponent>
    <div class="mt-6 overflow-x-auto">
      <table class="w-full table-auto">
        <thead class="">
        <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
          <template v-for="(value, _, index) in tableColumns" :key='index'>
            <th class="px-4 py-3" v-if="value.isVisibleInTable">{{ value.value }}</th>
          </template>
        </tr>
        </thead>
        <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium"
            v-for="(informacionRendimiento, index) of informacionRendimientos" :key="'A'+index">
          <td class="px-4 py-4 font-bold">
            {{ informacionRendimiento.nombre_banco }}
          </td>
          <td class="px-4 py-4 font-bold">
            {{ informacionRendimiento.cuenta_bancaria }} <br>
            ({{ informacionRendimiento.nombre_cuenta }})
          </td>
          <td class="px-4 py-4">
            <template v-for="(informacionMovimiento, indexp) of informacionRendimiento.informacionMovimientos"
                      :key="'B'+indexp">
              <div
                  :class="'py-3 bg-white hover:bg-gray-100 '+(indexp%2?'mt-3':'')">
                <span class="font-bold">{{ informacionMovimiento }}</span>
              </div>
              <div class="overflow-x-auto bg-white">
                <table class="w-full table-auto">
                  <thead>
                  <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase hover:bg-gray-100">
                    <th class="px-4 py-3">Descargar informes</th>
                    <th class="px-4 py-3">Rendimientos con tasa pactada</th>
                    <th class="px-4 py-3">Rendimientos con TIR</th>
                    <th class="px-4 py-3">No pagados (Diferencias)</th>
                    <th class="px-4 py-5">Opciones</th>
                  </tr>
                  </thead>
                  <tbody class="text-sm font-normal text-gray-700 text-center">
                  <template
                      v-for="(mes, indexm) of informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['meses']"
                      :key="'C'+indexm">
                    <tr class="py-10 bg-white hover:bg-gray-100 font-medium">
                      <td class="border border-black">
                        <button type="button"
                                @click="descargarInformeIndividual(informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['urls'][indexm])"
                                class="text-blue-600 border-0 w-full block"
                                v-if="informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['urls'][indexm]">
                          Descargar informe del mes
                          {{
                            getCurrentMonth(mes)
                          }}
                        </button>
                        <span v-else>No se ha generado ningún informe</span>
                      </td>
                      <td class="border border-black">
                        {{
                          separateNumberByComma(informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['interesesTasasPactadas'][indexm])
                        }}
                      </td>
                      <td class="border border-black">{{
                          separateNumberByComma(informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['interesesRealesPagados'][indexm])
                        }}
                      </td>
                      <td class="border border-black">
                        {{
                          separateNumberByComma(informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['noPagados'][indexm])
                        }}
                      </td>
                      <td class="border border-black flex flex-row">
                        <button
                            @click="calcular(informacionRendimiento, Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp], mes)"
                            class="text-white bg-green-500 p-2 hover:bg-green-600 focus:outline-none grow">
                          <span class="me-3">Calcular intereses de {{
                              getCurrentMonth(mes)
                            }}-{{ Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp] }}</span>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                               stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"/>
                          </svg>
                        </button>
                        <button v-if="informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['noPagados'][indexm] > 0"
                                :disabled="descargandoCuentaCobro"
                                class="calculate-header-cuenta-cobro text-white bg-blue-500 p-2 hover:bg-blue-600 focus:outline-none flex flex-col items-center disabled:bg-blue-300 disabled:cursor-not-allowed disabled:hover:bg-blue-300"
                                @click="descargarCuentaCobro(Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp], mes, informacionRendimiento['informacionMovimientosFull'][Object.keys(informacionRendimiento['informacionMovimientosFull'])[indexp]]['noPagados'][indexm],informacionRendimiento['cuenta_bancaria_id'])">
                          <span class="me-3">{{ descargandoCuentaCobro ? 'Generando...' : 'Descargar cuenta de cobro.' }}</span>
                          <svg v-if="descargandoCuentaCobro" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="w-5 h-5 animate-spin">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                          </svg>
                          <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </template>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <PaginateComponent :listar="listarInformacionRendimientos" :authToken="authToken" :paginate="paginate"
                       :optionalParams="[]"></PaginateComponent>
  </template>
  <!--  CALCULAR EXTRACTOS-->
  <CalcularExtractos :vista="view" @actualizarValores="actualizarValores" :selectedYear="selectedYear" :selectedMonth="selectedMonth"
                     :informacionCalculoMovimientos="informacionCalculoMovimientos"
                     :listarInformacionRendimientos="listarInformacionRendimientos" :listIngresos="listIngresos"
                     :listEgresos="listEgresos" @updateValues="(newValues)=>updateValues(newValues, this)"></CalcularExtractos>
</template>
<script>
import {ref, watch} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import {generateTextError, useAPIRest, verifyHttpCode} from "@/common/constants";
import {swal,swalRendimiento} from "@/common/constants/variables";
import {copiaProfunda, getCurrentMonth, separateNumberByComma} from "@/common/constants/functions";
import CalcularExtractos from "@/components/rendimientos/components/CalcularExtracto";
import PaginateComponent from "@/layouts/PaginateComponent";
import { updateValues } from "@/layouts/main";
import { writeFile, utils } from "xlsx-js-style";
import { downloadChargeAccount } from "@/common/constants";

export default {
  name: 'InformacionRendimientos',
  components: {CalcularExtractos, PaginateComponent, FilterRefactComponent},
  data: function () {
    return {
      getCurrentMonth: getCurrentMonth,
      separateNumberByComma: separateNumberByComma,
      descargandoInforme: false,
      descargandoCuentaCobro: false,
      tableColumns: {
        'bancoTasaEfectivaAnual.cuentaBancaria.banco.nombre_banco': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre del banco'
        },
        'bancoTasaEfectivaAnual.cuentaBancaria.cuenta_bancaria': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Cuenta bancaria'
        },
        'bancoTasaEfectivaAnual.mes': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Mes'
        },
        'bancoTasaEfectivaAnual.year': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Año'
        },
        'rendimiento_periodo': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          isValueRange: true,
          value: 'Rendimiento del periodo'
        },
        'informacionMovimientos': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'Movimientos registrados por año'
        }
      }
    }
  },
  async setup() {
    const informacionRendimientos = ref([]);
    const informacionCalculoMovimientos = ref([]);
    const selectedYear = ref(undefined)
    const selectedMonth = ref(undefined)
    const listIngresos = ref([]);
    const listEgresos = ref([]);
    const paginate = ref({
      "page": 1,
      "take": 10,
      "itemCount": 0,
      "pageCount": 1,
      "hasPreviousPage": false,
      "hasNextPage": false
    });
    const queries = ref({
      "orderBy": 'created_at',
      "order": 'ASC',
      "criterion": '',
      "search": ''
    })
    const view = ref('listar');
    const authStored = useAuth();
    const authToken = ref(authStored.authToken);
    /**
     * Retorna el acumulado de abonos recibidos por cada extracto bancario en una sola consulta.
     * @async
     * @function acumuladosAbonosPorExtracto
     * @param {string} tokenUpdated - Token actualizado del usuario autenticado.
     * @param {number[]} extractosIds - Ids de los extractos bancarios a consultar.
     * @returns {Promise<Object>} Acumulado de abonos indexado por id de extracto.
     * @throws {Error} Error HTTP obtenido de la API.
     */
    const acumuladosAbonosPorExtracto = async (tokenUpdated, extractosIds) => {
      if (!extractosIds.length) return {estado: 200, valor: {}};
      // El backend separa el where por comas, por eso el filtro se arma con OR dentro de un paréntesis explícito.
      const filtroExtractos = `(${extractosIds.map(extractoId => `table.extracto_bancario_destino_id = ${extractoId}`).join(' OR ')})`;
      const resJSON = await useAPIRest(process.env.VUE_APP_NEST_ABONOMESANTERIOR_FINDALL, 'GET', tokenUpdated, undefined, {
        select: 'table.extracto_bancario_destino_id AS extracto_destino_id, table.valor AS valor_abono',
        where: filtroExtractos,
        isPaginate: false
      });
      const {statusCode} = resJSON;
      delete resJSON.statusCode;
      if (!verifyHttpCode(statusCode, 'success')) return {estado: statusCode, valor: generateTextError(resJSON)};
      return {
        estado: statusCode,
        valor: resJSON.reduce((acumulados, abono) => {
          const extractoId = abono['extracto_destino_id'];
          acumulados[extractoId] = (acumulados[extractoId] ?? 0) + +abono['valor_abono'];
          return acumulados;
        }, {})
      };
    };
    /**
     * Retorna el detalle de rendimientos (años y meses) de varias cuentas bancarias en una sola consulta.
     * @async
     * @function listarDetalleRendimientos
     * @param {string} tokenUpdated - Token actualizado del usuario autenticado.
     * @param {number[]} cuentasBancariasIds - Ids de las cuentas bancarias de la página actual.
     * @returns {Promise<Object>} Detalle agrupado por cuenta bancaria y año.
     * @throws {Error} Error HTTP obtenido de la API.
     */
    const listarDetalleRendimientos = async (tokenUpdated, cuentasBancariasIds, select = 'distinct table.id AS extracto_id, banco_tasa_efectiva_anual.cuenta_bancaria_id, table.year, table.mes, table.url_informe, table.rendimiento_periodo, table.ganancia_interes_adicional, table.rendimiento_periodo_pagado_mes_siguiente, table.interes_tasa_pactada, table.tasa_efectiva_anual_real_pagada, banco_tasa_efectiva_anual.tasa_efectiva_anual AS tasa_e_a_banco', groupby = 'extracto_id, banco_tasa_efectiva_anual.cuenta_bancaria_id, table.year, table.mes, table.url_informe, table.rendimiento_periodo, table.ganancia_interes_adicional, table.rendimiento_periodo_pagado_mes_siguiente, table.interes_tasa_pactada, table.tasa_efectiva_anual_real_pagada, tasa_e_a_banco') => {
      const filtroCuentas = `(${cuentasBancariasIds.map(cuentaBancariaId => `banco_tasa_efectiva_anual.cuenta_bancaria_id = ${cuentaBancariaId}`).join(' OR ')})`;
      const resJSON = await useAPIRest(process.env.VUE_APP_NEST_INFORMACIONRENDIMIENTOS, 'GET', tokenUpdated, undefined, {
        select,
        groupby,
        ...queries.value,
        criterion: queries.value.criterion === 'cuentaBancaria.cuenta_bancaria' ? '' : queries.value.criterion,
        where: filtroCuentas,
        isPaginate: false
      });
      const {statusCode} = resJSON;
      delete resJSON.statusCode;
      if (!verifyHttpCode(statusCode, 'success')) return {estado: statusCode, valor: generateTextError(resJSON)};

      const resAbonos = await acumuladosAbonosPorExtracto(tokenUpdated, resJSON.map(res => res['extracto_id']));
      if (resAbonos.estado !== 200) return resAbonos;
      const acumuladosAbonos = resAbonos.valor;

      const detallePorCuenta = {};
      for (const res of [...resJSON].sort((a, b) => a.year - b.year || a.mes - b.mes)) {
        const cuentaBancariaId = res['cuenta_bancaria_id'];
        const year = res.year;
        if (!detallePorCuenta[cuentaBancariaId]) detallePorCuenta[cuentaBancariaId] = {};
        if (!detallePorCuenta[cuentaBancariaId][year]) detallePorCuenta[cuentaBancariaId][year] = {
          listMonth: [],
          meses: [],
          urls: [],
          rendimientosPeriodos: [],
          gananciasInteresesAdicionales: [],
          rendimientosPeriodosPagadosMesSiguiente: [],
          interesesRealesPagados: [],
          interesesTasasPactadas: [],
          noPagados: [],
          tasasEfectivasAnualesRealesPagadas: [],
          tasasEfectivasAnualesBanco: []
        };
        const detalleYear = detallePorCuenta[cuentaBancariaId][year];
        const rendimientoPeriodo = res['rendimiento_periodo'];
        const gananciaInteresAdicional = res['ganancia_interes_adicional'];
        const rendimientoPeriodoPagadoMesSiguiente = res['rendimiento_periodo_pagado_mes_siguiente'];
        const interesRealPagado = Number(rendimientoPeriodo) + Number(gananciaInteresAdicional) + Number(rendimientoPeriodoPagadoMesSiguiente);
        const interesTasaPactada = res['interes_tasa_pactada'];
        const acumuladoAbonosRecibidos = acumuladosAbonos[res['extracto_id']] ?? 0;
        detalleYear.listMonth.push(getCurrentMonth(res.mes));
        detalleYear.meses.push(res.mes);
        detalleYear.urls.push(res['url_informe']);
        detalleYear.rendimientosPeriodos.push(rendimientoPeriodo);
        detalleYear.gananciasInteresesAdicionales.push(gananciaInteresAdicional);
        detalleYear.rendimientosPeriodosPagadosMesSiguiente.push(rendimientoPeriodoPagadoMesSiguiente);
        detalleYear.interesesRealesPagados.push(interesRealPagado);
        detalleYear.interesesTasasPactadas.push(interesTasaPactada);
        detalleYear.noPagados.push((interesTasaPactada - interesRealPagado - acumuladoAbonosRecibidos).toFixed(2));
        detalleYear.tasasEfectivasAnualesRealesPagadas.push(res['tasa_efectiva_anual_real_pagada']);
        detalleYear.tasasEfectivasAnualesBanco.push(res['tasa_e_a_banco']);
      }
      return {estado: statusCode, valor: detallePorCuenta};
    };
    /**
     Lista la información de rendimientos de cuentas bancarias.
     @async
     @function
     @param {string} tokenUpdated - Token actualizado del usuario.
     @param {number} [page=1] - Número de página de la lista.
     @param {string} [select='distinct table.cuenta_bancaria_id, cuentaBancaria.cuenta_bancaria, banco.nombre_banco, banco.id AS banco_id'] - Campos a seleccionar de la consulta.
     @param {string} [groupby='table.cuenta_bancaria_id, banco.nombre_banco, cuentaBancaria.cuenta_bancaria'] - Campos para agrupar la consulta.
     @returns {Promise} - Promesa que resuelve la lista de información de rendimientos.
     */
     const listarInformacionRendimientos = async (tokenUpdated, page = 1, select = 'distinct banco_tasa_efectiva_anual.cuenta_bancaria_id, cuenta_bancaria.cuenta_bancaria, cuenta_bancaria.nombre_cuenta, banco.nombre_banco, banco.id AS banco_id', groupby = 'banco_tasa_efectiva_anual.cuenta_bancaria_id, banco.nombre_banco, cuenta_bancaria.cuenta_bancaria') => {
       try {
          swalRendimiento.fire({
            title: '<strong style="font-weight: bold; font-size: 2rem; color: #333;">Cargando...</strong>',
            html: `<p style="font-size: 1.2rem; color: #666;">Por favor espera</p>`,
            allowOutsideClick: false,
            showConfirmButton: false,
            background: 'white',
            didOpen: () => {
              swalRendimiento.showLoading();
            }
          });

          const resJSON = await useAPIRest(process.env.VUE_APP_NEST_INFORMACIONRENDIMIENTOS, 'GET', tokenUpdated, undefined, {
            page,
            select,
            groupby,
            ...queries.value
          });

          const { statusCode } = resJSON;
          delete resJSON.statusCode;
          const textoError = generateTextError(resJSON);

          if (!verifyHttpCode(statusCode, 'success')) {
            await swal.fire(textoError, '', 'error');
            return;
          }

          const cuentas = resJSON.data;

          // Todo el detalle de la página se resuelve en una sola consulta, no una por cuenta y año.
          if (cuentas.length) {
            const resDetalle = await listarDetalleRendimientos(tokenUpdated, cuentas.map(info => info.cuenta_bancaria_id));

            if (resDetalle.estado !== 200) {
              await swal.fire(resDetalle.valor, '', 'error');
              return;
            }

            for (const info of cuentas) {
              const detalleCuenta = resDetalle.valor[info.cuenta_bancaria_id] ?? {};
              const orderedYears = Object.keys(detalleCuenta).map(Number).sort((a, b) => a - b);

              info.informacionMovimientosFull = {};
              info.informacionMovimientos = [];
              orderedYears.forEach(year => {
                const {listMonth, ...detalleYear} = detalleCuenta[year];
                info.informacionMovimientosFull[year] = detalleYear;
                info.informacionMovimientos.push(`${year} (${listMonth.join(',')})`);
              });
            }
          }

          informacionRendimientos.value = cuentas;
          paginate.value = resJSON.meta;
        } catch (error) {
          console.error('Error en listarInformacionRendimientos:', error);
          await swal.fire('Error inesperado', '', 'error');
        } finally {
          swalRendimiento.close();
        }
     };
    /**
     Calcula los intereses de un extracto bancario.
     @param {object} informacionRendimientos - Información de rendimientos.
     @param {number} year - Año del extracto bancario.
     @param {number} mes - Mes del extracto bancario.
     @returns {Promise} - Promise que resuelve con el resultado del cálculo.
     */
    const calcular = async (informacionRendimientos, year, mes) => {
      return await
          swal.fire({
            title: '¿Desea realizar el calculo de intereses de este extracto?',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            cancelButtonText: 'Cancelar',
            confirmButtonText: '¡Realizar calculo!',
            customClass: {
              actions: 'm-0'
            },
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const informacionRendimientosUpdated = copiaProfunda(informacionRendimientos);
              delete informacionRendimientosUpdated['informacionMovimientosFull'];
              informacionRendimientosUpdated['informacionMovimientos'] = {
                [year]: [mes]
              };
              /**
               * Extracto bancario.
               * @type {object}
               */
              const extractoBancario = await useAPIRest(process.env.VUE_APP_NEST_EXTRACTOBANCARIO_FINDALL, 'GET', authToken.value, undefined, {
                page: 1,
                where: `banco_tasa_efectiva_anual.cuenta_bancaria_id=${informacionRendimientosUpdated.cuenta_bancaria_id},table.year=${year},table.mes=${mes},table.estado=true`,
                isPaginate: false
              }).then(resJSON => {
                const {statusCode} = resJSON;
                delete resJSON.statusCode;
                const textoError = generateTextError(resJSON);
                if (verifyHttpCode(statusCode, 'success')) return resJSON[0];
                else swal.fire(textoError, '', 'error');
              });
              /**
               * Tasa efectiva anual del banco.
               * @type {number}
               */
              const tasaBanco = extractoBancario['bancoTasaEfectivaAnual'].tasa_efectiva_anual;
              /**
               * Tasa efectiva anual de la entidad.
               * @type {number}
               */
              const tasaEAEntidad = extractoBancario.tasa_efectiva_anual_real_pagada;
              /**
               * Rendimiento del periodo.
               * @type {number}
               */
              const rendimientoPeriodo = extractoBancario.rendimiento_periodo;
              /**
               * Ganancia de interés adicional.
               * @type {number}
               */
              const gananciaInteresAdicional = extractoBancario.ganancia_interes_adicional;
              /**
               * Rendimiento del periodo pagado el mes siguiente.
               * @type {number}
               */
              const rendimientoPeriodoPagadoMesSiguiente = extractoBancario.rendimiento_periodo_pagado_mes_siguiente;
              informacionRendimientosUpdated['extracto_id'] = extractoBancario.id;
              informacionRendimientosUpdated['tasa_e_a_banco'] = parseFloat(tasaBanco);
              informacionRendimientosUpdated['tasa_e_a_entidad'] = parseFloat(tasaEAEntidad);
              informacionRendimientosUpdated['rendimiento_periodo'] = parseFloat(rendimientoPeriodo);
              informacionRendimientosUpdated['ganancia_interes_adicional'] = parseFloat(gananciaInteresAdicional);
              informacionRendimientosUpdated['rendimiento_periodo_pagado_mes_siguiente'] = parseFloat(rendimientoPeriodoPagadoMesSiguiente);
              return await useAPIRest(process.env.VUE_APP_NEST_INFORMACIONRENDIMIENTOS_EXTRAERINFORMACIONCALCULO, 'POST', authToken.value, {
                "informacion_rendimientos": JSON.stringify(informacionRendimientosUpdated)
              });
            },
            allowOutsideClick: () => !swal.isLoading()
          }).then(
              /**
               Función que maneja la respuesta de una promesa en caso de que sea confirmada.
               Si la respuesta es exitosa, asigna los valores correspondientes a las variables listIngresos, listEgresos e informacionCalculoMovimientos, y actualiza la view a 'calcularExtracto'.
               Si la respuesta no es exitosa, muestra un mensaje de error.
               */
              async result => {
                if (result.isConfirmed && result.value !== true) {
                  const resJSON = result.value;
                  const {statusCode} = resJSON;
                  delete resJSON['statusCode'];
                  if (verifyHttpCode(statusCode, 'errorServer')) await swal.fire('Error inesperado. Informar al administrador.', '', 'error');
                  else {
                    informacionCalculoMovimientos.value = result.value;
                    listIngresos.value = [];
                    listEgresos.value = [];
                    for (const value of Object.values(result.value[year][mes]['movimientos'])) {
                      const {ingreso, egreso} = value;
                      listIngresos.value.push(ingreso);
                      listEgresos.value.push(egreso);
                    }
                    view.value = 'calcularExtracto';
                    selectedYear.value = parseInt(year);
                    selectedMonth.value = mes;
                  }
                }
              });
    };
    watch(authToken, async (tokenUpdated, oldToken) => {
      if (!oldToken) await listarInformacionRendimientos(tokenUpdated);
    });
    watch(queries, async () => {
      await listarInformacionRendimientos(authToken.value);
    })
    if (authToken.value && !informacionRendimientos.value.length) await listarInformacionRendimientos(authToken.value);
    return {
      authToken,
      queries,
      informacionRendimientos,
      informacionCalculoMovimientos,
      selectedYear,
      selectedMonth,
      view,
      paginate, listIngresos, listEgresos,
      updateValues,
      listarInformacionRendimientos,
      calcular
    };
  },
  methods: {
    /**
     Descarga el informe individual en formato xlsx con el nombre de archivo especificado.
     @async
     @param {string} fileName - Nombre de archivo del informe individual a descargar.
     @returns {Promise<void>}
     */
    async descargarInformeIndividual(fileName) {
      await useAPIRest(process.env.VUE_APP_NEST_INFORMACIONRENDIMIENTOS_DESCARGARINFORME, 'GET', this.authToken, undefined, {
        'url': fileName
      }).then(async resJSON => {
        const {statusCode} = resJSON;
        delete resJSON.statusCode;
        const textoError = generateTextError(resJSON);
        if (verifyHttpCode(statusCode, 'success')) {
          const blob = await resJSON.blob();
          const newBlob = new Blob([blob], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          const url = window.URL.createObjectURL(newBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName.replace('src/assets/informes_rendimientos/', ''));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else await swal.fire(textoError, '', 'error');
      });
    },

    /**
     Genera y descarga la cuenta de cobro de un mes, evitando que varios clics consuman consecutivos de más.
     @async
     @param {string} anio - Año del extracto bancario.
     @param {number} mes - Mes del extracto bancario.
     @param {string} noPagados - Valor no pagado (diferencia) del mes.
     @param {number} cuentaBancariaId - Id de la cuenta bancaria.
     @returns {Promise<void>}
     */
    async descargarCuentaCobro(anio, mes, noPagados, cuentaBancariaId) {
      if (this.descargandoCuentaCobro) return;
      this.descargandoCuentaCobro = true;
      swalRendimiento.fire({
        title: '<strong style="font-weight: bold; font-size: 2rem; color: #333;">Generando cuenta de cobro...</strong>',
        html: `<p style="font-size: 1.2rem; color: #666;">Por favor espera</p>`,
        allowOutsideClick: false,
        showConfirmButton: false,
        background: 'white',
        didOpen: () => {
          swalRendimiento.showLoading();
        }
      });
      try {
        await downloadChargeAccount(anio, mes, this.authToken, noPagados, cuentaBancariaId);
      } catch (error) {
        console.error('Error al generar la cuenta de cobro:', error);
        await swal.fire(error.message ? error.message : 'No fue posible generar la cuenta de cobro. Informar al administrador.', '', 'error');
      } finally {
        this.descargandoCuentaCobro = false;
        swalRendimiento.close();
      }
    },

    async descargarInformeGrupal() {
      //Evita que varios clics lancen la generación del informe en paralelo
      if (this.descargandoInforme) return;
      this.descargandoInforme = true;
      swalRendimiento.fire({
        title: '<strong style="font-weight: bold; font-size: 2rem; color: #333;">Generando informe...</strong>',
        html: `<p style="font-size: 1.2rem; color: #666;">Por favor espera</p>`,
        allowOutsideClick: false,
        showConfirmButton: false,
        background: 'white',
        didOpen: () => {
          swalRendimiento.showLoading();
        }
      });
      try {
        //Recolección de los datos del listado de informacion rendimientos para una disposición más sencilla en el excel.
        //Las tasas ya vienen en el listado, por lo que no se consulta de nuevo cada extracto.
        const datos = [];
        for(const informacionRendimiento of this.informacionRendimientos) {
          const dato = {};
          dato.nombre_banco = informacionRendimiento.nombre_banco;
          dato.cuenta_bancaria = informacionRendimiento.cuenta_bancaria;
          dato.nombre_cuenta = informacionRendimiento.nombre_cuenta;
          dato.datosAnuales = {}
          for(const datoAnual in informacionRendimiento.informacionMovimientosFull) {
            const datosAnio = informacionRendimiento.informacionMovimientosFull[datoAnual];
            dato.datosAnuales[datoAnual] = {};
            for (let i = 0; i < datosAnio.meses.length; i++) {
              dato.datosAnuales[datoAnual][getCurrentMonth(datosAnio.meses[i])] = {
                rendimientos_tasa_pactada: datosAnio.interesesTasasPactadas[i],
                rendimientos_tir: datosAnio.rendimientosPeriodos[i],
                no_pagados: datosAnio.noPagados[i],
                tasa_e_a_banco: parseFloat(datosAnio.tasasEfectivasAnualesBanco[i]) || 0,
                tasa_e_a_entidad: parseFloat(datosAnio.tasasEfectivasAnualesRealesPagadas[i]) || 0
              }
            }
          }
          datos.push(dato);
        }

        //Relleno de los datos en una hoja de excel
        const contenidoExcel = [
          ['NOMBRE DEL BANCO', 'CUENTA BANCARIA', 'NOMBRE CUENTA BANCARIA', 'AÑO', 'MES', 'TASA PACTADA','RENDIMIENTOS CON TASA PACTADA', 'TASA REAL', 'RENDIMIENTOS CON TIR', 'NO PAGADOS (DIFERENCIAS)', 'VISTO BUENO?'],
          ['','','','','','','','','','']
        ];
        datos.forEach(dato => {
          for(const anio in dato.datosAnuales) {
            for(const mes in dato.datosAnuales[anio]){
              contenidoExcel.push([dato.nombre_banco, dato.cuenta_bancaria, dato.nombre_cuenta, anio, mes, dato.datosAnuales[anio][mes].tasa_e_a_banco + '%', dato.datosAnuales[anio][mes].rendimientos_tasa_pactada, dato.datosAnuales[anio][mes].tasa_e_a_entidad + '%', dato.datosAnuales[anio][mes].rendimientos_tir, dato.datosAnuales[anio][mes].no_pagados, dato.datosAnuales[anio][mes].no_pagados > 0?'No':'Sí'])
            }
          }
        })
        const workbook = utils.book_new();
        const worksheet = utils.aoa_to_sheet(contenidoExcel);

        //Apariencia del excel
        worksheet['!cols'] = [{wch: 20}, {wch: 20}, {wch: 40}, {wch: 9}, {wch: 20}, {wch: 5}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 10}, {wch: 5}];
        ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1'].forEach(cell => {worksheet[cell]['s'] = {font: {bold: true}}})
        utils.book_append_sheet(workbook, worksheet, 'informe');
        const fileName = 'informe_rendimientos.xlsx'
        writeFile(workbook, fileName, {
              type: 'binary',
              compression: true,
              bookType: 'xlsx',
          })
      } catch (error) {
        console.error('Error al generar el informe grupal:', error);
        await swal.fire('No fue posible generar el informe. Informar al administrador.', '', 'error');
      } finally {
        this.descargandoInforme = false;
        swalRendimiento.close();
      }
    },
    /**
     Limpia el formulario actual estableciendo todos los valores a una cadena vacía.
     @returns {void}
     */
    limpiarFormulario() {
      for (const data in this.form) {
        this.form[data] = '';
      }
    },
    /**
     Actualiza los valores de las propiedades del objeto actual con los valores proporcionados en el objeto especificado.
     @param {Object} objectoValor - Objeto que contiene los valores a actualizar.
     @returns {void}
     */
    actualizarValores(objectoValor) {
      for (const key in objectoValor) {
        this[key] = objectoValor[key];
      }
    }
  }
}
</script>